<template>
<!-- eslint-disable max-len -->
<div :class="`role-card ${categoryColor}`">
  <div class="role-card-icon">
    <!-- disabling direct use of fontawesome here because the domtoimage package can't handle it -->
    <!-- <i v-if="iconClass"
      :class="`fa fa-solid fa-${iconClass}`"
      style="width: 100%; height: 100%;"
    ></i> -->
    <img v-if="iconClass"
      class="role-icon"
      :src="`/static/reports/archetyperoles/${
        iconClass || 'briefcase-solid'
      }.png`"
    />
  </div>
  <div class="role-card-label">
    {{industryRole}}
  </div>
</div>
</template>

<script>
export default {
  props: {
    iconClass: String,
    categoryColor: String,
    industryRole: String,
  },
};
</script>

<style lang="scss" scoped>
.role-card {
  width: 150px;
  height: 183px;
  background-image: url('/static/reports/rolecardblue.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
  color: white;
  font-size: 14px;
  text-align: center;
}
.role-card.blue {
  background-image: url('/static/reports/rolecardblue.png');
}
.role-card.red {
  background-image: url('/static/reports/rolecardred.png');
}
.role-card.yellow {
  background-image: url('/static/reports/rolecardyellow.png');
}
.role-card-icon {
  width: 50%;
  height: 50%;

  // fontawesome positioning/sizing
  // margin-top: 12%;
  // font-size: 360%;

  // PNG positioning
  margin-left: 1%;
  margin-top: 15%;
}
.role-card-label {
  width: 87%;
  margin-bottom: 11%;
  line-height: 135%;
  text-align: center;
  vertical-align: middle;
  min-height: 18%;
}
.role-icon {
  width: 75%;
  height: 75%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/ReportIndustryRole.vue